import { BasePageComponent } from "@/components/base/BasePageComponent";
import { IntroDialogComponent } from "@/components/intro-dialog/intro-dialog.component";
import { IRealProperty } from "@/components/property-list/property-list.component";
import { ShareDialogComponent } from "@/components/share-dialog/share-dialog.component";
import { PropertyHelper } from "@/helpers/property.helper";
import { UserHelper } from "@/helpers/user.helper";
import { AppConfigService } from "@/services/app-config.service";
import { AuthenticationService } from "@/services/authentication.service";
import { NavService } from "@/services/nav.service";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import {
  HomeViewType,
  PropertiesService,
  PropertyAccessTypeFilter,
  PropertyChildrenTypeFilter,
  UserRole,
  UserSession,
} from "@eemo/api-client";
import {
  FilterPropertyListData,
  FiltersPropertyListComponent,
} from "../../components/filters-property-list/filters-property-list.component";
import { PropertyCardComponent } from "../../components/property-card/property-card.component";
import { PropertyListComponent as PropertyListComponent_1 } from "../../components/property-list/property-list.component";
import { RoundedLinkComponent } from "../../components/rounded-link/rounded-link.component";
import { MapModule } from "../../modules/map/map.module";

import { DataLoadingComponent } from "@/components/data-loading/data-loading.component";
import { PropertyCardListComponent } from "@/components/property-card-list/property-card-list.component";
import { TooltipDirective } from "@/directives/tooltip/tooltip.directive";
import { NgFor, NgIf } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatTabsModule } from "@angular/material/tabs";
import { Subscription } from "rxjs";
import { coreEnvironment } from "src/environments/core/core-environment";
import { FloatMenuComponent } from "../../components/float-menu/float-menu.component";

@Component({
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  standalone: true,
  imports: [
    FloatMenuComponent,
    MatTabsModule,
    NgIf,
    MatIconModule,
    NgFor,
    PropertyCardComponent,
    RoundedLinkComponent,
    MapModule,
    MatButtonModule,
    FiltersPropertyListComponent,
    PropertyListComponent_1,
    TooltipDirective,
    DataLoadingComponent,
    PropertyCardListComponent,
  ],
})
export class HomeComponent
  extends BasePageComponent
  implements OnInit, OnDestroy
{
  static readonly TAB_INDEX_GRID = 0;
  static readonly TAB_INDEX_MAP = 1;
  static readonly TAB_INDEX_LIST = 2;

  currentUser: UserSession;

  selectedTabIndex: number;
  canSeePropertyCardList = true;
  canSeePropertyMap = false;
  canSeePropertyList = false;
  canSeePropertyArchives = false;

  searchEnabled = false;
  userReachedPropertyLimit = false;
  selectedProps: IRealProperty[] = [];
  userHasShare = false;

  lightColumns = coreEnvironment.tables.property.home.lightColumns;
  filterData: FilterPropertyListData;
  newlist: IRealProperty[] = [];
  PropertyChildrenTypeFilter = PropertyChildrenTypeFilter;
  reload = 0;

  subs: Subscription[] = [];

  constructor(
    private authenticationService: AuthenticationService,
    protected navService: NavService,
    private propertiesService: PropertiesService,
    public propertyHelper: PropertyHelper,
    public userHelper: UserHelper,
    private dialog: MatDialog,
    private appConfigService: AppConfigService,
    protected route: ActivatedRoute
  ) {
    super(route, navService);
    this.subs.push(
      this.authenticationService.currentUser.subscribe((value) => {
        if (value) {
          this.currentUser = value;
        }
      })
    );
    this.canSeePropertyCardList = !this.userHelper.isRescueService();
    this.canSeePropertyMap = !this.userHelper.isIndividual();
    this.canSeePropertyList =
      this.userHelper.isAdmin() ||
      this.userHelper.isRealEstate() ||
      userHelper.isNotary();
    this.canSeePropertyArchives =
      this.userHelper.isAdmin() ||
      this.userHelper.isRealEstate() ||
      userHelper.isNotary();
    this.selectedTabIndex = HomeComponent.TAB_INDEX_GRID;
    this.subs.push(
      this.appConfigService.userPreferencesObs.subscribe((preferences) => {
        if (preferences) {
          if (preferences.homeView === HomeViewType.MAP) {
            this.selectedTabIndex = HomeComponent.TAB_INDEX_MAP;
          } else if (preferences.homeView === HomeViewType.LIST) {
            this.selectedTabIndex = HomeComponent.TAB_INDEX_LIST;
          }
        }
      })
    );
  }

  ngOnInit() {
    this.loadPropertyList();
    this.searchEnabled = this.userHelper.isMapSearchEnabled();

    if (
      this.appConfigService.showIntro &&
      this.currentUser.role !== UserRole.ADMIN &&
      this.currentUser.role !== UserRole.EEMO &&
      this.currentUser.role !== UserRole.RESCUE_SERVICE &&
      (this.appConfigService.isDemo() ||
        this.currentUser.lastConnectionDate === undefined)
    ) {
      this.showIntro();
    } else {
      this.appConfigService.showIntro = false;
    }
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

  loadPropertyList() {
    if (this.userHelper.isAccountTypeFree(this.currentUser.accountType)) {
      // request property to check the number
      this.subs.push(
        this.propertiesService
          .getRealPropertyList(
            PropertyAccessTypeFilter.MINE,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            0,
            5
          )
          .subscribe((d) => {
            this.userReachedPropertyLimit =
              this.userHelper.hasReachedPropertyLimit(d.list);
            this.appConfigService.userReachedPropertyLimit =
              this.userReachedPropertyLimit;
          })
      );
    }
  }

  addShares() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      this.dialog.open(ShareDialogComponent, {
        data: { props: this.selectedProps },
      });
    }
  }

  showIntro() {
    // prevents to open multiple dialog
    if (this.dialog.openDialogs.length === 0) {
      const dialogRef = this.dialog.open(IntroDialogComponent, {
        data: { userHasShare: this.userHasShare },
      });

      dialogRef.afterClosed().subscribe(() => {
        this.appConfigService.showIntro = false;
      });
    }
  }

  onTabChange(selectedIndex: number) {
    this.selectedTabIndex = selectedIndex;
  }
}
